import React from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../../../components/header";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { SendIcon } from "../../../components/icons";
import { useCategories } from "../hooks";

export const Categories: React.FC = () => {
  const navigate = useNavigate();
  const { data, loading } = useCategories();

  return (
    <>
      <Header
        title="Catégories"
        subtitle="Liste des catégories"
        buttons={[
          {
            actionText: "Nouvelle catégorie",
            bgColor: "indigo",
            textColor: "white",
            link: `/category/create`,
            icon: <SendIcon />,
          },
        ]}
      />

      <div className="main-container">
        <div className="p-4 mb-6 bg-white shadow rounded overflow-x-auto">
          {loading ? (
            <Loading />
          ) : !data?.categories?.results?.length ? (
            <EmptyList text="Aucune catégorie" />
          ) : (
            <Table>
              <TableHeader>
                <TableRow hover={false}>
                  <TableCell header>Nom</TableCell>
                  <TableCell header align="center">
                    Nombre de clients
                  </TableCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                {data?.categories?.results?.map((category) => (
                  <TableRow
                    key={`category-${category.id}`}
                    onClick={() => navigate(`/category/${category.id}`)}
                  >
                    <TableCell>{category.name}</TableCell>
                    <TableCell align="center">{category.sitesCount}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </div>
      </div>
    </>
  );
};
